export default () => {
  // I want to use position: sticky but the overflow: hidden ancestor prevents it from working.
  // Using an intersection observer instead with a sticky sentinel.
  let callback = (el) => (entries) => {
    entries.forEach((entry) => {
      const sentinel = entry.target;

      // If the sentinel is above the top of the viewport, add sticky.
      if (entry.boundingClientRect.y < 0) {
        // Sentinel takes up the space of the original element so that the
        // page position does not jump.
        sentinel.style.height = el.offsetHeight + 'px';
        el.classList.add('sticky');

      // If the sentinel is below the top of the viewport, remove sticky.
      } else {
        sentinel.style.height = null;
        el.classList.remove('sticky');
      }
    });
  };

  let options = {
    threshold: [0, 1],
  }

  const sticky = document.querySelectorAll('[data-sticky]');

  sticky.forEach((el) => {
    const sentinelId = el.dataset.sticky;
    const sentinel = document.getElementById(sentinelId);
    if (!sentinel) { // currently only supporting sticky using a sentinel element
      return;
    }

    let observer = new IntersectionObserver(callback(el), options);
    observer.observe(sentinel);
  });
};
